import React from 'react';
import { Box, Chip, Typography } from '@drone-js/core';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { InCitySearchFilterContentProps, mapStateToProps, mapDispatchToProps } from 'component/page/search/InCitySearchFilterContent/InCitySearchFilterContent.selectors';
import { StringFormatter } from '@agoda/react-handyman';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesDismissInCitySearchClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesDismissInCitySearchClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';

const InCitySearchFilterContentComponent: React.FC<InCitySearchFilterContentProps> = (props) => {
    const navigate = useNavigate();
    const location = props.navigation.location;

    const handleChipInteraction = () => {
        trackElementEvent<ActivitiesDismissInCitySearchClickEventActivitiesFieldsV1>(ActivitiesDismissInCitySearchClickEventActivitiesManifestV1.ids, {
            search_phrase: props.keyword,
            city_id: props.geo?.cityId || 0,
        });
        location && props.onDismissKeyword(location.search, props.isAct4518, navigate);
    };

    return (
        <Box pb="12" display="inline-flex" alignItems="center" pt={props.isMobile ? '12' : '0'}>
            <Typography variant="body-s-strong" textColor="base.subtle" pe="8" data-element-name="activities-in-city-search-result" data-testid="activities-in-city-search-result">
                {StringFormatter.format(props.cms[317677], props.totalActivities)}
            </Typography>
            {props.geo?.cityName && props.keyword && (
                <Chip
                    label={props.keyword}
                    selection="selected"
                    dismissible={true}
                    dismissLabel={StringFormatter.format(props.cms[152705], props.geo.cityName)}
                    iconLabel={`${StringFormatter.format(props.cms[317677], props.totalActivities)} ${props.geo.cityName}`}
                    onDismiss={handleChipInteraction}
                    data-testid="activities-in-city-keyword-chip"
                    size="s"
                />
            )}
        </Box>
    );
};

InCitySearchFilterContentComponent.displayName = 'InCitySearchFilterContentComponent';

export default connect(mapStateToProps, mapDispatchToProps)(InCitySearchFilterContentComponent);
